module.exports = __webpack_public_path__ + "img/logo5.b2da0a87.png";